module.exports = __webpack_public_path__ + "img/sieckFinesseSwing1.2bc0bb9b.png";